import React, { useState } from "react";
import styled from "@emotion/styled";

import FormHelper from "../../utils/FormHelper";
import Form from "../../components/LoginBox/Form";
import FormBox from "../../components/LoginBox/FormBox";

const SignUpPasswordBox = (props) => {
  const { dataHelper, userHelper, navigate, location, message, config } = props;
  const [loading, setLoading] = useState(0);

  const inputs = SignupPasswordform(props);
  const prevFormData = location?.state;

  const handleSignUpPassword = async (formData) => {
    let username = prevFormData?.Email;

    let response = await userHelper.checkUserExists(
      { username },
      "signupPassword"
    );

    if (response?.success && response?.code) {
      switch (response.code) {
        case "user-exists":
          return {
            success: false,
            redirect: ["/cadastro", { state: { formData: prevFormData } }],
          };
        // case "user-needs-password-definition":
        //   return {
        //     success: true,
        //     redirect: [
        //       routes.accessCode.path,
        //       { UserFirebaseId: response.UserFirebaseId },
        //     ],
        //   };
        //   break;
        case "user-does-not-exist":
          return await handleSignUp(formData);
        default:
          break;
      }
    } else {
      message.add({
        type: "error",
        message:
          "Não foi possível processar sua requisição. Por favor, tente novamente mais tarde.",
      });
    }
  };

  const handleSignUp = async (formData) => {
    let userData = {
      Username: prevFormData?.Email,
      Password: formData?.Password,
      CheckedTerms: formData?.TermsConfirmation,
      ...prevFormData,
      source: "Landing Page - Avanti Premiado",
      campaign: "Cadastro Avanti Premiado"
    };

    if (userData.Email) {
      userData.Email = userData.Email.toLowerCase().replace(/\s/g, "");
    }

    let response = await userHelper.saveUser(userData);

    if (response.success) {
      global.isAuthenticated = true;

      return {
        success: true,
        redirect: "/",
      };
    } else {
      let showErrorMessage = true;
      let errorMessage = "";
      response.goBack = true;

      if (response?.error?.code) {
        switch (response.error.code) {
          case "missing-terms":
            errorMessage = "Você precisa aceitar os termos para prosseguir.";
            response.goBack = false;
            break;
          case "auth/username-already-in-use":
          case "auth/email-already-in-use":
          case "auth/email-already-exists":
            errorMessage = "Este e-mail já está em uso";
            break;
          case "auth/cpf-already-in-use":
            errorMessage = "Este CPF já está cadastrado";
            break;
          case "no-uid":
            errorMessage =
              "Não foi possível identificar o usuário. Por favor, recarregue a página e tente novamente.";
            break;
          case "error-recordType":
            errorMessage = "Erro ao buscar record-Type";
            break;
          case "auth/requires-recent-login":
            message.add({
              type: "error",
              body: "Seu login expirou. Por favor, tente novamente.",
              persist: true,
            });

            return {
              success: true,
              redirect: "/login",
            };
            break;
          default:
            errorMessage =
              "Não foi possível processar sua requisição. Por favor, tente novamente mais tarde.";
        }
      } else if (response?.message) {
        errorMessage = response.message;
      } else {
        errorMessage =
          "Não foi possível processar sua requisição. Por favor, tente novamente mais tarde.";
      }

      if (response.goBack) {
        message.add({ type: "error", body: errorMessage, persist: true });

        return {
          success: true,
          redirect: "/cadastro",
        };
      } else if (showErrorMessage) {
        message.add({ type: "error", body: errorMessage });
      }
    }
  };

  return (
    <StyledSignUpPasswordBox>
      <FormBox
        {...props}
        config={config}
        title="Senha"
        description="Crie uma senha forte:"
        inside={
          <>
            <Form
              navigate={navigate}
              location={location}
              dataHelper={dataHelper}
              config={config}
              inputs={inputs}
              handleSend={handleSignUpPassword}
              loading={loading}
              setLoading={setLoading}
              sendLabel="Continuar"
            />
          </>
        }
      />
    </StyledSignUpPasswordBox>
  );
};

export default SignUpPasswordBox;

/* form */

const SignupPasswordform = (props) => {
  return {
    Password: FormHelper.useFormInput({
      id: "password",
      label: "Senha",
      type: "password",
      validations: [
        {
          type: "required",
          errorMessage: "Digite sua senha",
        },
        {
          type: "length",
          minLength: 6,
          errorMessage: "Senha precisa ter pelo menos 6 caracteres",
        },
        // {
        //   type: "passwordTips",
        //   errorMessage: "Senha deve preencher os requisitos abaixo",
        // },
      ],
      // contentTips: [
      //   "chars:8",
      //   "uppercase:1",
      //   "lowercase:1",
      //   "number:1",
      //   "symbol:1",
      // ],
    }),
    PasswordConfirmation: FormHelper.useFormInput({
      id: "password-confirmation",
      label: "Confirme a senha",
      type: "password",
      validations: [
        {
          type: "required",
          errorMessage: "Digite a confirmação da senha",
        },
        {
          type: "custom",
          errorMessage: "A senha e confirmação devem ser idênticas",
          customFunction: async (formInput, validation, aInputs) => {
            let isValid = true;

            aInputs.every((input) => {
              if (
                input.id === "password" &&
                input.getValue() !== formInput.getValue()
              ) {
                isValid = false;
                return false;
              }

              return true;
            });

            return isValid;
          },
        },
      ],
      append: (
        <span style={{ color: "rgba(0, 59, 33, 1)" }}>
          Sua senha deve ter no mínimo 6 caracteres. Para uma senha forte,
          combine letras, números e símbolos.
        </span>
      ),
    }),
    TermsConfirmation: FormHelper.useFormInput({
      id: "terms-confirmation",
      label: `Li e aceito os <a href="${"https://appoficial-arquivos.s3.sa-east-1.amazonaws.com/Termos_app/SEP+TERMOS+DE+USO.pdf"}" target="_blank" style="text-decoration: underline; font-weight: bold;">Termos e Condições</a> e a <a href="${"https://appoficial-arquivos.s3.sa-east-1.amazonaws.com/Termos_app/20210910+PALMEIRAS+-+Pol%C3%ADtica+de+Privacidade+e+Confidencialidade+(sem+Cookies)+complementada.pdf"}" target="_blank" style="text-decoration: underline; font-weight: bold;">Política de Privacidade de dados</a>`,
      type: "checkbox",
      validations: [
        {
          type: "required",
          errorMessage: "Marque a caixa de seleção para continuar",
        },
      ],
    }),
  };
};

/* styles */

const StyledSignUpPasswordBox = styled.div`
  display: flex;
  flex-direction: column;
  gap: 48px;
  align-items: center;
  margin-top: 42px;
  height: 100%;
`;
